module.exports = __webpack_public_path__ + "img/lob-notifications.46e40885.svg";